// extracted by mini-css-extract-plugin
export default {"name":"OrganizationsTable_name__N3fas","table":"OrganizationsTable_table__wtFNl"};